/**
 * PATH: apps/inventory/src/pages/DashboardPage.tsx
 * PURPOSE: Inventory Hub Dashboard
 */
import { EmptyRegister } from './emptyRegister'

export default function DashboardPage() {
  return (
    <EmptyRegister
      title="Inventory Dashboard"
      detail="No stock totals are connected."
    />
  )
}
